import { useState, useEffect, useRef } from "react";
import { createModel } from "hox";
import { message } from "antd";
import useGlobalModel, { transPgToPagination } from "@/model/globalModel";
import { useLockFn } from "ahooks";
import { enquiryService } from "../../../dtpService";
import { TablePaginationConfig } from "antd/lib/table";
import { DEFAULT_PAGE_SIZE, DEFAULT_FIRST_PAGE_NUM } from "@/utils/constants";
import { ISupplierOfferSearch, ISupplierOfferDetails, ISupplierPriceDialog, ISupplierMaterialDetails, IDtpMaterialDetail } from "../../../dtpTypes";
import { formatNum, formatInt } from "@/utils/utils";
import { useDtpDetailModel } from "../dtpDetailModel";
import { globalPrompt } from "@/components/message";
import { DictCodeEnmu } from "@/types/AppDictEnums";
import { convertRes2Blob } from "@/utils/exportFile";


export const useSupplierOfferModel = createModel(function () {
    const { user: { shopCode, shopName }, setLoadingInfo } = useGlobalModel(({ user }) => [user]);
    const { editFormVal } = useDtpDetailModel(({ editFormVal }) => [editFormVal])
    //单据code
    const [enquiryCode, setEnquiryCode] = useState<string>("");

    /**列表 */
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    const [dataSource, setDataSource] = useState<ISupplierOfferDetails[]>([]);
    const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);

    const loadData = async (page: ISupplierOfferSearch = initPgCfg) => {
        const searchParams = {
            code: editFormVal.code ?? enquiryCode,
            shopCode,
            pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
            pageNum: (page?.current || page?.pageNum) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
        }
        let { retData } = await enquiryService.pageOffer(searchParams);
        const { records, ...pg } = retData;
        setPgCfg(transPgToPagination(pg));
        // setDataSource(records);
    }

    //作废
    const dispbleOffer = async (id?: string) => {
        let { retData } = await enquiryService.disableOffer(id ?? selectedRowKeys[0]);
        loadData();
        setSelectedRowKeys([])
        globalPrompt("message", { text: "操作成功", type: "success" })
    }
    /**详情 */

    //供应商报价信息弹框
    const [supplierDialog, setSupplierDialog] = useState<ISupplierPriceDialog>({
        visible: false,
        mode: 'add'
    });
    const [formVal, setFormVal] = useState<ISupplierOfferDetails>({ id: "", shopName });
    const [materialList, setMaterialList] = useState<ISupplierMaterialDetails[]>([]);
    const [selectedMaterialRowKeys, setSelectedMaterialRowKeys] = useState<string[]>([]);

    //商品子表添加
    const insertMaterial = (arr: IDtpMaterialDetail[]) => {
        setMaterialList(origin => {
            let newArr: ISupplierMaterialDetails[] = [...origin];
            arr.forEach(material => {
                //选中的是否存在列表
                let isExist = origin.find(item => item.materialCode == material.materialCode);
                if (!isExist) {
                    let num = +formatInt(material.num);
                    let price = formatNum(material.price);
                    newArr.push({
                        key: material.id,
                        "inquiryOrderDetailsId": material.id,         //    // "询价单详情id",
                        "materialCode": material.materialCode,         //    // "物料编号",
                        "replaceCode": material.replaceCode,        //    // "替换号",
                        "materialName": material.materialName,       //    // "物料名称",
                        "materialEname": material.materialEname,        //    // "物料名称",
                        "typeCode": material.typeCode,       //    // "物料类型",
                        "typeName": material.typeName,       //    // "物料类型名称",
                        "num": num,      //|    // 5,
                        "price": price,      //|    // 99,
                        "amount": formatNum(num * +price),       //|    // 99,
                        "model": material.model,         //    // "规格",
                        "note": ""         //    // "备注"
                    })
                }
            });
            return newArr;
        });
        setSupplierMaterialDialog(false);
    }

    //重置缓存
    const resetCache = () => {
        setFormVal({ id: "", shopName });
        setMaterialList([]);
        setSelectedRowKeys([]);
    }

    //获取供应商报价one
    const getSupplierMaterialOne = async (id?: string) => {
        let { retData } = await enquiryService.oneOffer(id ?? selectedRowKeys[0]);
        let { details, ...formVal } = retData;
        if (retData) {
            setFormVal(formVal);
            setMaterialList(details?.map(item => ({ ...item, key: item.id ?? "" })) ?? []);
        }
        return retData;
    }


    //报价单新增 | 编辑
    const insertOrUpdateSupplierOffer = useLockFn(async (mode: string, val: ISupplierOfferDetails) => {
        let data = {
            ...val,
            relevanceOrderId: editFormVal.relevanceOrderId,
            inquiryOrderCode: editFormVal.code,
            shopCode,
            amountTotal: materialList.reduce((con, next) => { con = con + +(next.amount ?? 0); return con }, 0),
            details: materialList.map(item => {
                let { createTime, createUser, deleteFlag, updateTime, updateUser, key, giftsNum, ...param } = item;
                return param;
            })
        };
        //新增
        if (mode === "edit") {
            let { retData } = await enquiryService.updateOffer({ ...data, id: formVal.id, code: formVal.code });
            loadData()
            message.success("编辑成功")
            return retData;
        } else {
            let { retData } = await enquiryService.insertOffer(data);
            loadData()
            message.success("新增成功")
            return retData;
        }
    })

    //出口报价
    const transferOffer = async () => {
        if (editFormVal.status === DictCodeEnmu.INQUIRY_CANCEL) {
            message.warning("作废的询价单不可转接出口报价单");
            return;
        }
        if (!selectedRowKeys.length) {
            return message.warning("请选择数据进行编辑");
        };
        let { retData } = await enquiryService.transferOffer({ shopCode, code: selectedRowKeys.join() });
        message.success("出口报价成功,自动跳转报价单详情");
        return retData;
    }

    //明细导出
    const exportDtp = async () => {
        setLoadingInfo({ loadingVisible: true, txt: "快速导出中" });
        try {
            let result = await enquiryService.offerExport(formVal.code ?? "", shopCode);
            result && setLoadingInfo({ loadingVisible: false, txt: "" });
            convertRes2Blob(result);
        } catch { setLoadingInfo({ loadingVisible: false, txt: "" }) }
    }

    //报价单明细下载模板
    const offerDownloadTpl = async () => {
        let result = await enquiryService.offerDownloadTpl();
        convertRes2Blob(result);
    }

    //获取上传url  (询价单code)
    const getUploadUrl = () => {
        return `/gtm/supplierOffer/detail/import/${editFormVal.code ?? enquiryCode}/${shopCode}`
    }

    /**商品弹框 */
    //供应商报价-添加商品信息弹框
    const [supplierMaterialDialog, setSupplierMaterialDialog] = useState<boolean>(false);
    return {
        /***field***/
        editFormVal,
        enquiryCode, setEnquiryCode,
        dataSource, pgCfg,
        supplierDialog, setSupplierDialog,
        selectedRowKeys, setSelectedRowKeys,
        supplierMaterialDialog, setSupplierMaterialDialog,
        materialList, setMaterialList,
        formVal, setFormVal,
        selectedMaterialRowKeys, setSelectedMaterialRowKeys,
        /***method***/
        loadData,
        insertOrUpdateSupplierOffer,
        getSupplierMaterialOne,
        resetCache,
        insertMaterial,
        dispbleOffer,
        transferOffer,
        exportDtp,
        offerDownloadTpl,
        getUploadUrl
    }
});